import { Box, styled } from '@mui/material';

export const StyledScrollContainer = styled(Box)(() => ({
  overflow: 'auto',
  width: '100%',
}));

export const StyledContainer = styled(Box)(
  ({ center = true }: { center?: boolean }) => ({
    margin: center ? 'auto' : '0',
    padding: '20px',
    width: '100%',
  }),
);
